import { useEffect, useState } from 'react';

import { loadTinymce } from './tinymce';

export const useTinymce = () => {
  const [loading, setLoading] = useState(!window.tinymce);

  useEffect(() => {
    if (window.tinymce) {
      setLoading(false);
      return;
    }

    let cancelled = false;
    loadTinymce().then(() => {
      if (!cancelled) setLoading(false);
    });

    return () => {
      cancelled = true;
    };
  }, []);

  return { loading };
};
